import { PageHeader } from '@celltrak/ui-components';

const ProcedureHeader = () => (
  <header>
    <PageHeader title="Procedure Codes" />
  </header>
);

export default ProcedureHeader;
